module.exports = __webpack_public_path__ + "static/legends-8-324ba19d9b21baf8aa5123edaa9924a0.jpg";